<div class="row">
  <div class="col-md-12">
    <form #f="ngForm" (ngSubmit)="doAction(f)" ngNativeValidate class="was-validated">
      <fieldset>
        <h3>Formulario de alta | modificación {{ entity }}</h3>
      </fieldset>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Código</label>
            <input #serie (keydown.enter)="changeCodbar()" (blur)="changeCodbar()" type="text" name="serie" id="serie"
              [(ngModel)]="item.serie" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese código barra</small>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Nombre de mercaderia</label>
            <input disabled="{{ blocker }}" type="text" required="true" name="mercaderia" id="mercaderia"
              [(ngModel)]="item.nombre" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese Nombre de mercaderia</small>
          </div>
        </div>

        <div class="col-md-4">
          <app-cb-grupo [require]="true" [disable]="blocker" [dibujar]="item.grupo" (select)="itemSel($event)">
          </app-cb-grupo>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">Precio de compra</label>
            <input disabled="{{ blocker }}" type="number" step="any" required="true" name="precioCom" id="precioCom"
              [(ngModel)]="item.precioCom" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese precio compra</small>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="">Precio con tarjeta</label>
            <input disabled="{{ blocker }}" type="number" step="any" required="true" name="precioLis" id="precioLis"
              [(ngModel)]="item.precioLis" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese precio tarjeta</small>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="">Precio con debito/Qr</label>
            <input disabled="{{ blocker }}" type="number" step="any" required="true" name="precioDeb" id="precioDeb"
              [(ngModel)]="item.precioDeb" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese precio debito/Qr</small>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="">Precio de Contado</label>
            <input disabled="{{ blocker }}" type="number" step="any" required="true" name="precioCon" id="precioCon"
              [(ngModel)]="item.precioCon" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese precio contado</small>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="">Precio de Mayorista</label>
            <input disabled="{{ blocker }}" type="number" step="any" required="true" name="precioMay" id="precioMay"
              [(ngModel)]="item.precioMay" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese precio mayorista</small>
          </div>
        </div>
        <div *ngIf="item.precioMay > 0" class="col-md-3">
          <div class="form-group">
            <label for="">Cantidad de oferta</label>
            <input disabled="{{ blocker }}" type="number" step="any" required="true" name="cantOferta" id="cantOferta"
              [(ngModel)]="item.cantOferta" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese cantidad a partir que se aplica la oferta</small>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label for="">Stock minimo</label>
            <input disabled="{{ blocker }}" type="number" step="any" required="true" name="stockMin" id="stockMin"
              [(ngModel)]="item.stockMin" class="form-control" placeholder="" aria-describedby="helpId" />
            <small id="helpId" class="text-muted">Ingrese stock minimo</small>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label for="">Descripción</label>
            <textarea disabled="{{ blocker }}" type="text" rows="4" cols="12" name="descripcion" id="descripcion"
              [(ngModel)]="item.descripcion" class="form-control" placeholder="" aria-describedby="helpId"></textarea>
            <small id="helpId" class="text-muted">Ingrese descripcion</small>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="masVendido" id="masVendido"
              [(ngModel)]="item.masVendido" [disabled]="blocker" />
            <label class="form-check-label" for="masVendido">
              Más Vendido
            </label>
            <small class="text-muted d-block">Tilde para más vendido</small>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="mostrar" id="mostrar" [(ngModel)]="item.mostrar"
              [disabled]="blocker" />
            <label class="form-check-label" for="mostrar">
              Mostrar
            </label>
            <small class="text-muted d-block">Tilde para mostrarlo en el carrito</small>
          </div>
        </div>


        <div class="col-md-6">
          <app-lst-colors (finalizado)="setColor($event)" [listado]="item.colores"></app-lst-colors>
        </div>
        <div class="col-md-12">
          <app-photo (imagenB64)="setImg($event)" [view]="item.photo"></app-photo>
        </div>
      </div>

      <button type="submit" [disabled]="blocker" name="btnA" id="btnA" class="btn btn-primary btn-lg btn-block">
        <i class="fas fa-check"></i>
        aceptar
      </button>
    </form>
  </div>
  &nbsp;
  <div class="col-md-12">
    <a [routerLink]="['/admin/' + entity + '/lst']" class="btn btn-secondary btn-lg btn-block">
      <i class="fas fa-arrow-left"></i> Volver
    </a>
  </div>
</div>